import React, { useState } from 'react';
import { getInitials } from 'utils/fnData';
import translate from 'utils/fnTranslate';
import { PersonRole } from 'types/Asset';
import { ARROW_ANCHOR, CardWrapper } from 'components/Lane/Lane.css';
import fallbackPerson from 'assets/images/person_fallback.png';
import fallbackKid from 'assets/images/kid_fallback.png';
import { LinkTrackable } from 'components/Trackable/LinkTrackable';
import { CardImage } from 'style/styled-components/reusable.css';
import { StandardCover } from 'types/Cover';
import {
    CircleCardImageContainer,
    CircleCardTitle,
    CircleCardTitleWrapper,
    CircleCardWrapper,
    InitialsFallback,
    CircleCardSubtitle,
} from './CardCircle.css';

export type PropTypes = {
    asset: StandardCover;
};

export const CardCircle: React.FC<PropTypes> = ({ asset, ...rest }) => {
    const [showFallBackInitials, setShowFallbackInitials] = useState<boolean>(false);
    const isKidCharacter = asset.path && asset.path.includes('kids');

    return (
        <CardWrapper width={'auto'} height={'auto'}>
            <LinkTrackable
                to={asset.path || ''}
                onClick={(e) => {
                    if (!asset.path) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    asset.onClick?.(e, null);
                }}
                visibleFocus="outline"
                {...rest}
            >
                <CircleCardWrapper>
                    <CircleCardImageContainer data-test-id={'castmember-circle'} {...{ [ARROW_ANCHOR]: '' }}>
                        {showFallBackInitials &&
                            (isKidCharacter ? (
                                <CardImage url={fallbackKid} alt="" />
                            ) : (
                                <InitialsFallback aria-hidden>{getInitials(asset.title)}</InitialsFallback>
                            ))}
                        {!showFallBackInitials && (
                            <CardImage
                                url={asset.customImage || asset.image}
                                fallbackImage={fallbackPerson}
                                alt=""
                                {...{
                                    imageError: () => {
                                        setShowFallbackInitials(true);
                                    },
                                }}
                            />
                        )}
                    </CircleCardImageContainer>
                    <CircleCardTitleWrapper>
                        <CircleCardTitle data-test-id={'tv-detailscreen-circlecardtitle'}>{asset.title}</CircleCardTitle>
                        {asset.role === PersonRole.DIRECTOR && <CircleCardSubtitle>{translate('PERSON_ROLE_DIRECTOR')}</CircleCardSubtitle>}
                    </CircleCardTitleWrapper>
                </CircleCardWrapper>
            </LinkTrackable>
        </CardWrapper>
    );
};
